export default {
    transactions_requests_title: 'Transactions Requests',
    transactions_requests_transaction: 'Id',
    transactions_requests_message: ' Error Message',
    transactions_requests_data: 'Data',
    transactions_requests_duplicated_device: "Duplicated Device",
    transactions_requests_success: "Success",
    transactions_requests_failure: "Failure",
    transactions_requests_pending: "Pending",
    transactions_requests_show_data: 'Show Data',

    transactions_requests_company_name: "Account",
    transactions_requests_type: 'Type',
    transactions_requests_project_id: "Platform",
    transactions_requests_processing_status: "Status",
    transactions_requests_created: "Created",
    transactions_requests_created_by: 'Created By',
    transactions_requests_updated: "Updated",
    transactions_requests_id: "Transaction Id",
    transactions_requests_script_calamp_devices: "Script Calamp Devices",
    transactions_requests_create_queclink_devices: "Create Queclink Devices",
    transactions_requests_import_units: "Import Units",
    transactions_requests_vidFleet_reboot_devices: "VidFleet Reboot Devices",
    transactions_requests_reprocess_odo_hrs: "Reprocess Odo/Hrs",
    transactions_requests_diagnostic_units: "Diagnostic Units",
    transactions_requests_date_range: "Date Range",
    transactions_requests_resync: "Sync Data to Zonar",
};
